// extracted by mini-css-extract-plugin
module.exports = {"debug":"section_debug__3JPip","sectionContainer":"section_sectionContainer__24PEa","content":"section_content__3-0us","grey":"section_grey__1Lo5t"};